<template>
  <div :class="['grid grid--two checkout-login-register ', { 'grid--align-top': (deliveryAddress.isCompanyCustomer !== null && deliveryAddress.isCompanyCustomer || deliveryAddress.isCompanyCustomer !== null && !deliveryAddress.isCompanyCustomer) && isOpen }]">
    <div class="sign-in">
      <h2 v-epi-edit="'LoginHeader'" class="sign-in__header">
        {{ t('loginHeader') }}
      </h2>

      <p class="sign-in__description">
        {{ t('signInDescription') }}
      </p>

      <oie-sign-in-box
        register-url="registerUrl"
        :enable-merge-cart="false"
        :fetch-invoice-data="true">
      </oie-sign-in-box>
    </div>

    <div class="sign-in sign-in--register">
      <h2 class="sign-in__header">
        {{ t('checkoutRegisterHeader') }}
      </h2>

      <p class="sign-in__description">
        {{ t('checkoutRegisterDescription') }}
      </p>

      <div ref="checkoutSignUp">
        <h3 class="expandable-item__heading">
          <oie-base-action size="large" data-pw="checkout-signup-button" @click="toggleAccordion()">
            {{ t('buttonGuestLabel') }}
          </oie-base-action>
        </h3>
        <validation-observer
          v-if="isOpen"
          ref="checkoutSignUpForm"
          tag="form"
          class="checkout-sign-up">
          <div class="checkout-section__item">
            <validation-provider v-slot="{ errors }" rules="required">
              <fieldset
                class="input-column__container input-column__container--register"
                aria-required="true"
                :aria-invalid="errors.length ? 'true' : 'false'"
                role="radiogroup">
                <legend class="sr-only">
                  {{ tStatic('selectCustomerTypeAria') }}
                </legend>

                <oie-base-radio-checkbox
                  v-model="selectedCustomerType"
                  value="company"
                  name="customer-type"
                  area-describedby="customer-type-error"
                  :playwright="'customer-type-company'"
                  :label="t('signUpCompanyLabel')"></oie-base-radio-checkbox>

                <oie-base-radio-checkbox
                  v-model="selectedCustomerType"
                  value="private"
                  name="customer-type"
                  area-describedby="customer-type-error"
                  :playwright="'customer-type-private'"
                  :label="t('signUpPrivateLabel')"></oie-base-radio-checkbox>

                <div
                  v-show="errors.length"
                  :id="`customer-type-error`"
                  class="body-smaller base-radio-checkbox__error customer-type-error">
                  <oie-base-icon icon="warning" size="xs"></oie-base-icon>
                  <span v-for="error in errors" :key="error">
                    {{ error }}
                  </span>
                </div>
              </fieldset>
            </validation-provider>

            <div v-if="deliveryAddress.isCompanyCustomer !== null" class="input-column__container">
              <h3 class="input-column__header">
                {{ t('customerInformationLabel') }}
              </h3>

              <validation-provider
                v-if="useCountryDropDown && (hasMultipleMarkets || clientModel.impersonating)"
                v-slot="{errors}"
                rules="required"
                slim>
                <oie-base-dropdown
                  v-if="hasMultipleMarkets || clientModel.impersonating"
                  v-model="deliveryAddress.countryCode"
                  :label-text="`${tStatic('addressCountryLabel')}*`"
                  :default-selected="createDefaultSelection"
                  :options="clientModel.countryList"
                  :initial-text="createInitialText"
                  :use-filter-functionality="clientModel.countryList.length > 10"
                  :filter-input-placeholder="tStatic('addressCountryPlaceholder')"
                  :is-disabled="!hasMultipleMarkets"
                  container-classes="order-request__dropdown"
                  name="checkout-sign-up"
                  z-index="10"
                  :error-messages="errors"
                  data-pw="country-dropdown"
                  @input="updateModelWithFormatingProperties">
                </oie-base-dropdown>
              </validation-provider>

              <template v-if="!useCountryDropDown && (hasMultipleMarkets || clientModel.impersonating)">
                <fieldset role="radiogroup" class="input-column__container input-column__container--register">
                  <legend class="input__label">
                    {{ tStatic('addressCountryLabel') }}
                  </legend>
                  <oie-base-radio-checkbox
                    v-for="country in clientModel.countryList"
                    :key="'country' + country.value"
                    v-model="deliveryAddress.countryCode"
                    :value="country.value"
                    name="country"
                    :label="country.text"></oie-base-radio-checkbox>
                </fieldset>
              </template>

              <div v-if="clientModel.impersonating" class="input-column__container">
                <oie-base-dropdown
                  v-model="deliveryAddress.language"
                  :label-text="tStatic('superUserUserPreferredLanguage')"
                  :options="clientModel.availibleLanguages"
                  :use-filter-functionality="false"
                  :default-selected="createDefaultLanguageSelection"
                  :is-disabled="clientModel.availibleLanguages.length <= 1"
                  name="user-language"
                  container-classes="order-request__dropdown">
                </oie-base-dropdown>
              </div>

              <validation-provider
                v-if="deliveryAddress.isCompanyCustomer"
                v-slot="{errors}"
                rules="required|invalidchars"
                slim>
                <oie-base-input-v2
                  v-if="deliveryAddress.isCompanyCustomer"
                  v-model="deliveryAddress.customerName"
                  :label="t('companyNameLabel')"
                  :placeholder="t('companyNamePlaceholder')"
                  required
                  data-pw="company-name"
                  :errors="errors"></oie-base-input-v2>
              </validation-provider>

              <validation-provider
                v-if="deliveryAddress.isCompanyCustomer && selectedActiveCountry && selectedActiveCountry.useVatCode"
                v-slot="{errors}"
                :debounce="500"
                :rules="createVatNumberValidateRule"
                slim>
                <oie-vat-input
                  v-if="deliveryAddress.isCompanyCustomer && selectedActiveCountry && selectedActiveCountry.useVatCode"
                  v-model="formatingProperties.vatNumber"
                  :label="vatNumberLabel"
                  :placeholder="t('companyVATPlaceholder')"
                  :errors="errors"
                  :country-code="selectedActiveCountry ? selectedActiveCountry.value.replace(/^GR/, 'EL') : null"
                  :playwright="'vat-number'"
                  maxlength="18"
                  @blur="updateModelWithFormatingProperties()"></oie-vat-input>
              </validation-provider>

              <validation-provider
                v-if="!deliveryAddress.isCompanyCustomer"
                v-slot="{ errors, validate, valid }"
                name="Förnamn"
                rules="required|invalidchars|firstNameNoPN"
                slim>
                <oie-base-input-v2
                  v-if="!deliveryAddress.isCompanyCustomer"
                  v-model="deliveryAddress.firstName"
                  maxlength="49"
                  required
                  data-pw="first-name"
                  :label="t('privateNameLabel')"
                  :placeholder="t('privateNamePlaceholder')"
                  :errors="errors"
                  @input="validate">
                </oie-base-input-v2>
              </validation-provider>

              <validation-provider
                v-if="!deliveryAddress.isCompanyCustomer"
                v-slot="{errors}"
                rules="required|invalidchars|lastNameNoPN"
                slim>
                <oie-base-input-v2
                  v-if="!deliveryAddress.isCompanyCustomer"
                  v-model="deliveryAddress.lastName"
                  maxlength="50"
                  required
                  data-pw="last-name"
                  :label="t('privateLastNameLabel')"
                  :placeholder="t('privateLastNamePlaceholder')"
                  :errors="errors"></oie-base-input-v2>
              </validation-provider>

              <validation-provider
                v-slot="{errors}"
                rules="required|mobile:^[0-9+]+$"
                slim>
                <oie-phone-input
                  v-model="formatingProperties.phoneNumber"
                  :label="t('phoneNumberLabel')"
                  :placeholder="t('phoneNumberPlaceholder')"
                  maxlength="27"
                  required
                  :playwright="'mobile'"
                  :errors="errors"
                  :country-code="selectedActiveCountry ? selectedActiveCountry.callingCode : null"
                  @blur="updateModelWithFormatingProperties()"></oie-phone-input>
              </validation-provider>

              <validation-provider
                v-if="!deliveryAddress.noemail"
                v-slot="{errors}"
                rules="required|email|invalidEmailCharacters"
                slim>
                <oie-base-input-v2
                  v-model="deliveryAddress.username"
                  required
                  :label="tStatic('email')"
                  :placeholder="tStatic('emailPlaceholder')"
                  data-pw="username"
                  maxlength="80"
                  :errors="errors"></oie-base-input-v2>
              </validation-provider>

              <oie-base-radio-checkbox
                v-if="clientModel.impersonating"
                v-model="deliveryAddress.noemail"
                label="Kund saknar epostadress">
              </oie-base-radio-checkbox>
            </div>

            <div v-if="deliveryAddress.isCompanyCustomer !== null" class="input-column__container">
              <h3
                class="input-column__header">
                {{ t('addressHeaderLabel') }}
              </h3>

              <oie-address-component id="checkout-signup" :address="deliveryAddress" :use-country-dropdown="false"></oie-address-component>

              <oie-base-radio-checkbox
                v-if="!deliveryAddress.noemail"
                v-model="deliveryAddress.newsletter"
                :label="t('newsletterLabel')"></oie-base-radio-checkbox>

              <oie-base-radio-checkbox
                v-if="!deliveryAddress.noemail"
                v-model="deliveryAddress.toggleUserPassword"
                class="input-column__checkbox"
                :label="t('createUserToggleHeader')"
                :playwright="'create-account'">
              </oie-base-radio-checkbox>
            </div>

            <section v-if="deliveryAddress.toggleUserPassword">
              <h3
                v-if="!deliveryAddress.noemail && deliveryAddress.isCompanyCustomer"
                class="input-column__header">
                {{ t('userDetailsHeader') }}
              </h3>

              <div class="input-column__container">
                <validation-provider
                  v-if="deliveryAddress.isCompanyCustomer"
                  v-slot="{errors}"
                  rules="required|invalidchars|firstNameNoPN"
                  slim>
                  <oie-base-input-v2
                    v-model="deliveryAddress.firstName"
                    required
                    maxlength="49"
                    :label="t('privateNameLabel')"
                    :placeholder="t('privateNamePlaceholder')"
                    :errors="errors"></oie-base-input-v2>
                </validation-provider>

                <validation-provider
                  v-if="deliveryAddress.isCompanyCustomer"
                  v-slot="{errors}"
                  rules="required|invalidchars|lastNameNoPN"
                  slim>
                  <oie-base-input-v2
                    v-model="deliveryAddress.lastName"
                    required
                    maxlength="50"
                    :label="t('privateLastNameLabel')"
                    :placeholder="t('privateLastNamePlaceholder')"
                    :errors="errors"></oie-base-input-v2>
                </validation-provider>

                <h3
                  v-if="!deliveryAddress.noemail"
                  class="input-column__header">
                  {{ t('createUserLabel') }}
                </h3>

                <fieldset v-if="clientModel.impersonating && !deliveryAddress.noemail" class="input-column__container" role="radiogroup">
                  <legend class="sr-only">
                    Lösenordsåterställning
                  </legend>
                  <oie-base-radio-checkbox
                    v-model="formatingProperties.passwordReset"
                    name="sendResetPassword"
                    value="automatic"
                    label="Skicka automatiskt återställ lösenord epost"></oie-base-radio-checkbox>

                  <oie-base-radio-checkbox
                    v-model="formatingProperties.passwordReset"
                    name="sendResetPassword"
                    value="manual"
                    label="Ange lösenord manuellt"></oie-base-radio-checkbox>
                </fieldset>

                <template v-if="!deliveryAddress.noemail && !deliveryAddress.sendResetPassword">
                  <validation-provider
                    v-slot="{errors}"
                    vid="pw"
                    rules="required|passwordPolicy"
                    slim>
                    <oie-base-input-v2
                      v-model="deliveryAddress.password"
                      type="password"
                      autocomplete="new-password"
                      required
                      :description="tStatic('passwordPolicy')"
                      :label="t('createUserPasswordLabel')"
                      :placeholder="t('createUserPasswordPlaceholder')"
                      data-pw="password"
                      :errors="errors"></oie-base-input-v2>
                  </validation-provider>

                  <validation-provider
                    v-slot="{errors}"
                    rules="required|password:pw"
                    slim>
                    <oie-base-input-v2
                      v-model="deliveryAddress.reEnteredPassword"
                      type="password"
                      :label="t('createUserRepeatPasswordLabel')"
                      required
                      :placeholder="t('createUserRepeatPasswordPlaceholder')"
                      data-pw="password-repeat"
                      :errors="errors"></oie-base-input-v2>
                  </validation-provider>
                </template>
              </div>

              <div class="checkout-sign-up__margin-to-checkbox">
                <validation-provider v-slot="{errors}" rules="checked" slim>
                  <oie-base-radio-checkbox
                    v-model="deliveryAddress.approveTerms"
                    required
                    :label="t('approveTermsLabel')"
                    :description="t('approveTermsInformation')"
                    :errors="errors"
                    :playwright="'signup-approve-terms'"
                    class="input-column__checkbox"></oie-base-radio-checkbox>
                </validation-provider>
              </div>
              <div
                v-if="clientModel.impersonating && !deliveryAddress.approveTerms"
                class="superuser-terms-reminder">
                {{ tStatic('superUserCheckoutTermsReminder') }}
              </div>
            </section>
          </div>

          <oie-base-action
            v-if="!isStepActive(componentIndex) && deliveryAddress.isCompanyCustomer !== null"
            :component-index="componentIndex"
            size="large"
            data-pw="signup-next-step"
            @click="validateStep">
            {{ t('wizardNextStep') }}
          </oie-base-action>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import accordionMixin from '@/mixins/accordion.js'
import nextStepMixin from '@/mixins/checkout-next-step.js'
import { mapGetters } from 'vuex'
import countryHandling from '@/mixins/country-handling'
import _ from 'lodash'
import utils from '@/core/utils'
import { CHECKOUT_RESET_PAYMENT, CHECKOUT_RESET_SHIPPING, CHECKOUT_SIGN_UP } from '@/variables/checkout-event-keys'
import { extend } from 'vee-validate'

export default {
  mixins: [accordionMixin, nextStepMixin, countryHandling],
  props: {
    eventKey: {
      type: String,
      default: null
    }
  },
  data: () => ({
    deliveryAddress: {
      isCompanyCustomer: null,
      username: null,
      password: null,
      customerName: null,
      firstName: null,
      lastName: null,
      phone: null,
      addressLine1: null,
      addressCo: null,
      postalCode: null,
      city: null,
      countryCode: null,
      countryName: null,
      vatNumber: '',
      newsletter: false,
      pdfInvoice: true,
      pdfReceipt: true,
      reEnteredPassword: '',
      toggleUserPassword: true,
      noemail: false,
      sendResetPassword: false,
      approveTerms: false,
      language: null
    },
    formatingProperties: {
      phoneNumber: null,
      vatNumber: null,
      passwordReset: 'manual'
    },
    isCompanyCustomerInitialized: false,
    isVatNumberInitialized: false,
    selectedCustomerType: null
  }),
  computed: {
    ...mapGetters('checkout', ['checkoutState', 'isOrderRequestVisitorState']),
    ...mapGetters('commerce', ['cart']),
    ...mapGetters(['enableGtm']),
    createDefaultSelection() {
      return (this.checkoutState !== undefined && this.checkoutState.deliveryAddress !== undefined) ? this.checkoutState.deliveryAddress.countryCode : null
    },
    createVatNumberValidateRule() {
      let countryCode
      if (countryHandling.selectedActiveCountry) {
        countryCode = countryHandling.selectedActiveCountry.value
      } else if (this.deliveryAddress.countryCode) {
        countryCode = this.deliveryAddress.countryCode
      }
      return countryCode ? `vatNumber:${countryCode.replace(/^GR/, 'EL')}` : null
    },
    vatNumberLabel() {
      if (this.clientModel.currentMarket === 'se' || this.clientModel.currentMarket === 'no') {
        return this.t('companyOrgNrLabel')
      } else {
        return this.t('companyVATLabel')
      }
    },
    createDefaultLanguageSelection() {
      if (this.clientModel.availibleLanguages.find(l => l.isDefault)) {
        return this.clientModel.availibleLanguages.find(l => l.isDefault).value
      }
      return this.clientModel.availibleLanguages[0].value
    }
  },
  watch: {
    deliveryAddress: {
      deep: true,
      handler(updatedAddress) {
        this.updateAddress(updatedAddress)
      }
    },
    'formatingProperties.passwordReset': {
      handler(value) {
        this.deliveryAddress.sendResetPassword = value === 'automatic'
      },
      immediate: true
    },
    'selectedCustomerType'() {
      this.deliveryAddress.isCompanyCustomer = this.selectedCustomerType === 'company'
      this.publish('checkout-container-customer-type', this.deliveryAddress.isCompanyCustomer)
    },
    'deliveryAddress.countryCode'() {
      this.setActiveCountry(this.deliveryAddress.countryCode)
    },
    'deliveryAddress.isCompanyCustomer'(value) {
      if (!value) {
        this.deliveryAddress.vatNumber = ''
        this.formatingProperties.vatNumber = null
      }
      this.publish('checkout-container-customer-id-number', null)
      if (this.isCompanyCustomerInitialized) {
        this.restartStep1()
      }

      this.isCompanyCustomerInitialized = true
    },
    'deliveryAddress.vatNumber'() {
      this.publish('checkout-container-customer-id-number', null)
      if (this.isVatNumberInitialized) {
        if (this.deliveryAddress.vatNumber && this.deliveryAddress.isCompanyCustomer && this.clientModel.marketUseVatCode) { this.restartStep1() }
      }

      this.isVatNumberInitialized = true
    },
    'deliveryAddress.noemail'() {
      if (this.deliveryAddress.noemail && !this.deliveryAddress.toggleUserPassword) {
        this.deliveryAddress.toggleUserPassword = true
      }
      if (this.deliveryAddress.noemail) {
        this.deliveryAddress.username = null
      }
    },
    'deliveryAddress.toggleUserPassword'() {
      if (!this.deliveryAddress.toggleUserPassword && this.deliveryAddress.noemail) {
        this.deliveryAddress.noemail = false
      }
    }
  },
  created() {
    extend('firstNameNoPN', {
      validate: value => {
        if (!value) return false

        const hasLetter = /[A-Za-zÀ-ÖØ-öø-ÿ]/.test(value)
        if (!hasLetter) return false

        const pnPattern = /^\d{10,12}$/
        if (pnPattern.test(value)) return false

        return true
      },
      message:
        this.tStatic('firstNameNoPNValidationMessage')
    })

    extend('lastNameNoPN', {
      validate: value => {
        if (!value) return false

        const hasLetter = /[A-Za-zÀ-ÖØ-öø-ÿ]/.test(value)
        if (!hasLetter) return false

        const pnPattern = /^\d{10,12}$/
        if (pnPattern.test(value)) return false

        return true
      },
      message:
          this.tStatic('lastNameNoPNValidationMessage')
    })

    extend('invalidEmailCharacters', {
      validate: value => {
        if (!value) return false

        const hasInvalidLetter = /^(?!.*[À-ÖØ-öø-ÿ]).+$/.test(value)
        if (!hasInvalidLetter) return false

        return true
      },
      message:
      this.tStatic('validateEmailCharacters')
    })
  },
  mounted () {
    if (this.checkoutState.deliveryAddress !== undefined && (this.checkoutState.deliveryAddress.username || this.checkoutState.deliveryAddress.password || this.checkoutState.deliveryAddress.firstName || this.checkoutState.deliveryAddress.lastName || this.checkoutState.deliveryAddress.customerName)) {
      this.isOpen = true
    }

    if (this.checkoutState.deliveryAddress !== null && this.checkoutState.deliveryAddress !== undefined) {
      // Make sure deliveryAdress reactivity is preserved
      Object.keys(this.deliveryAddress).forEach((key) => {
        if (this.checkoutState.deliveryAddress[key] !== undefined) {
          this.$set(this.deliveryAddress, key, this.checkoutState.deliveryAddress[key])
        }
      })

      if (this.deliveryAddress.countryCode) {
        this.formatingProperties.phoneNumber = utils.extractPhoneNumberFromFormating(this.deliveryAddress.phone, this.getCallingCode())
        this.formatingProperties.vatNumber = utils.extractVatNumberFromFormating(this.deliveryAddress.vatNumber, this.deliveryAddress.countryCode.replace(/^GR/, 'EL'))
      }

      if (this.deliveryAddress.isCompanyCustomer !== null && this.deliveryAddress.isCompanyCustomer !== undefined) {
        this.selectedCustomerType = this.deliveryAddress.isCompanyCustomer ? 'company' : 'private'
      } else {
        this.deliveryAddress.isCompanyCustomer = false
      }
    }
  },
  methods: {
    validateStep() {
      this.$refs.checkoutSignUpForm.validate().then((valid) => {
        if (valid) {
          if (this.deliveryAddress.toggleUserPassword && this.deliveryAddress.approveTerms) {

          }
          this.publish(`checkout-wizard-step-${this.componentIndex}`, this.componentIndex)
        }
      })
    },
    updateAddress: _.debounce(function(updatedAddress) {
      this.publish(CHECKOUT_SIGN_UP, updatedAddress)
    }, 500),
    updateModelWithFormatingProperties() {
      if (this.formatingProperties.phoneNumber && this.deliveryAddress.countryCode !== null) {
        const currentCountry = this.countryList.find(c => c.value === this.deliveryAddress.countryCode)

        if (currentCountry) {
          this.deliveryAddress.phone = utils.savePhoneNumberWithFormating(this.formatingProperties.phoneNumber, currentCountry.callingCode)
          this.formatingProperties.phoneNumber = utils.extractPhoneNumberFromFormating(this.formatingProperties.phoneNumber, currentCountry.callingCode)
        }
      } else if (this.formatingProperties.phoneNumber && this.formatingProperties.phoneNumber !== null && this.formatingProperties.phoneNumber.length === 0 && this.deliveryAddress.phone) {
        this.deliveryAddress.phone = null
      }

      if (this.formatingProperties.vatNumber && this.deliveryAddress.countryCode !== null) {
        this.deliveryAddress.vatNumber = this.formatingProperties.vatNumber
        if (this.customer) {
          this.customer.idNumber = this.deliveryAddress.vatNumber
        }
      } else {
        this.deliveryAddress.vatNumber = null
      }
    },
    getCallingCode() {
      return this.countryList.find(c => c.value === this.deliveryAddress.countryCode).callingCode
    },
    restartStep1() {
      const isStepTwoActive = this.isStepActive(1)
      const isStepThreeActive = this.isStepActive(2)

      if (isStepTwoActive || isStepThreeActive) {
        if (isStepTwoActive) {
          this.publish(CHECKOUT_RESET_PAYMENT)
        }

        if (isStepThreeActive) {
          this.publish(CHECKOUT_RESET_SHIPPING)
        }

        if (isStepTwoActive || isStepThreeActive) {
          this.removeOnlyActiveSteps([2, 3, 4])
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .checkout-login-register .sign-in {
  @include brand-border;
  padding: measure(full);
  background-color: color(background-white);
  border: 1px solid color(border-gray);
  border-bottom: 0;
  }

  .checkout-sign-up__customer-type {
  display: flex;
  }

  .checkout-sign-up__customer-type > *:first-child {
  margin-right: measure(full);
  }

  .checkout-sign-up .input-column__container {
  max-width: 24rem;
  }

  .checkout-sign-up .checkout-sign-up__margin-to-checkbox {
  margin-top: measure(full);
  }

  .checkout-sign-up .superuser-terms-reminder {
  background-color: #ffa;
  border: #999 1px solid;
  text-align: center;
  padding: measure(quarter);
  }
</style>
